import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Route, RouterLinkComponent } from '@web/common';

@Component({
  selector: 'app-footer-router-link',
  imports: [RouterLinkComponent],
  templateUrl: './footer-router-link.component.html',
  styleUrl: './footer-router-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterRouterLinkComponent {
  public readonly route = input.required<Route>();
  public readonly text = input.required<string>();
  public readonly fragment = input<string>();
}
